import { atom } from 'jotai';
import type { SerializedHashTable } from '@src/scenario-editor/utils/serializer';
import { MAX_HISTORY_LENGTH } from '@src/consts.ts';
import { createStore } from 'jotai/index';

export const historyAtom = atom<SerializedHashTable[]>([]);

export const cursorAtom = atom(-1);
export const historyNavigationFlagAtom = atom(false);

const historyNavigationFlagStore = createStore();
export const getHistoryNavigationFlag = () => historyNavigationFlagStore.get(historyNavigationFlagAtom);
export const setHistoryNavigationFlag = (flag: boolean) => historyNavigationFlagStore.set(historyNavigationFlagAtom, flag);

export const historyPushAtom = atom(null, (get, set, newRecord: SerializedHashTable) => {
  const history = get(historyAtom);
  const cursorValue = get(cursorAtom);

  if (history.length > 0) {
    const lastRecord = history[cursorValue];
    const lastRecordStringified = JSON.stringify(lastRecord);
    const newRecordStringified = JSON.stringify(newRecord);
    if (lastRecordStringified === newRecordStringified || Object.keys(newRecord).length === 0) {
      return;
    }
  }

  const newHistory = [...history.slice(0, cursorValue + 1), newRecord] as SerializedHashTable[];

  if (newHistory.length > MAX_HISTORY_LENGTH) {
    newHistory.shift();
  }

  set(historyAtom, newHistory);
  set(cursorAtom, cursorValue + 1);
});

export const moveCursorAtom = atom(null, (get, set, direction: number) => {
  const cursor = get(cursorAtom) + direction;
  const history = get(historyAtom);

  if (cursor >= 0 && cursor < history.length) {
    set(cursorAtom, cursor);
  }
});
